import { make } from 'vuex-pathify';

const state = {
  sites: {},
  feeds: {},
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations,
};
